import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function videoReducer(state = initialState.videoState, action) {
    switch(action.type) {
        case types.GET_VIDEO:
            return {
                ...state,
                selectedVideo: action.video
            }
        case types.GET_VIDEO_CHARTS:
            return {
                ...state,
                charts: action.charts,
                chartsLastLoaded: new Date()
            }
        case types.GET_VIDEO_CHARTS_STATUS:
            return {
                ...state,
                chartLoadingStatus: action.loadingStatus
            } 
        case types.PLAY_VIDEO:
            //do nothing, we don't need to do anything when a video is playing - magnific handled it
            return state;
        case types.INCREASE_VIDEO_RATING:
        {
            const videoID = action.videoRating.id;
            const rating = action.videoRating.rating; 
            return {
                ...state,
                charts: state.charts.map(video => {
                    if(video.ID === videoID){
                      return { ...video, Rating: rating }
                    }
                    return video
                  }),
            }
        }
        case types.UPDATE_VIDEO_RATING:
        {
            const videoID = action.videoRating.id;
            const rating = action.videoRating.rating; 
            return {
                ...state,
                charts: state.charts.map(video => {
                    if(video.ID === videoID){
                      return { ...video, Rating: rating };
                    }
                    return video;
                  }),
                selectedVideo: state.selectedVideo && state.selectedVideo.Video ? 
                    { 
                        ...state.selectedVideo, 
                        Video: { ...state.selectedVideo.Video, Rating: rating }, 
                        OtherVideos: state.selectedVideo.OtherVideos.map(video => {
                            if(video.ID === videoID){
                                return { ...video, Rating: rating };
                              }
                              return video;
                        })
                    } 
                    : state.selectedVideo 
            };
        }
        default:
            return state;
    }
}